module.exports = __webpack_public_path__ + "images/花筑村全景_09.jpg?v=3b2a1bd1";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_09.jpg
 ** module id = 105
 ** module chunks = 1 2
 **/